import { render, staticRenderFns } from "./AbstractTable.vue?vue&type=template&id=5d66a260&"
import script from "./AbstractTable.vue?vue&type=script&lang=ts&"
export * from "./AbstractTable.vue?vue&type=script&lang=ts&"
import style0 from "./AbstractTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports